import React, { Component } from "react";
import {
  Navbar,
  Nav,
  Row,
  Col,
  Container,
  Offcanvas,
  Modal,
  Button,
  Form,
  Dropdown,
} from "react-bootstrap";
import CookieConsent from "react-cookie-consent";
import { Formik } from "formik";
import { connect } from "react-redux";
import { signin } from "./../../store/actions/AuthActions";
import { toast } from "react-toastify";
import { signinSchema } from "./../../helpers/validation/signin";
import { withRouter, Link } from "react-router-dom";
import { withCookies } from "react-cookie";
import "./css/Index.css";

const expiry = localStorage.getItem("ltdn_exp");
const currentTime = Date.now() / 1000;
const authenticated = expiry > currentTime;

class Index extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,

      privilege: 0,

      showModal: false,
    };
  }

  componentDidMount = () => {
    this.setState({
      isAuthenticated: authenticated,
      privilege: parseInt(localStorage.getItem("ltdn_priv")) });
  };

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  render() {
    const { isAuthenticated, showModal, privilege } = this.state;
    const { cookies } = this.props;

    return (
      <Col sm="12">
      <Row>
        <Col className="navbar-col">
        <Navbar bg="light" expand="lg" className="navbar navbar-scrolled">
          {/* Use a wider container on desktop */}
          <Container
          fluid="md"
          style={{
            maxWidth: "1600px", // Increase max width for desktop
            marginLeft: "auto",
            marginRight: "auto",
          }}
          >
          {/* Navbar.Toggle moved before Navbar.Brand for mobile left alignment */}
          <div className="d-lg-none d-flex align-items-center">
            <Navbar.Toggle />
          </div>
          <Navbar.Brand className="navbar-brand ms-0 ms-lg-2" as={Link} to="/">
            <img
            src={require("./../common/img/logo.png")}
            alt="litudian"
            />
          </Navbar.Brand>
          {/* Use Navbar.Offcanvas for responsive navigation */}
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="start"
            style={{ width: "75vw", maxWidth: "75vw" }}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel">
                <img
                  src={require("./../common/img/logo.png")}
                  alt="litudian"
                  style={{ height: "32px" }}
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                {isAuthenticated === true && (
                  <>
                    {/* Always visible links */}
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin" style={{ marginBottom: "8px" }}>
                      Home
                    </Nav.Link>
                    { privilege === 2 && (
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/users" style={{ marginBottom: "8px" }}>
                      Users
                    </Nav.Link>
                    )}
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/products" style={{ marginBottom: "8px" }}>
                      Products
                    </Nav.Link>
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/categories" style={{ marginBottom: "8px" }}>
                      Categories
                    </Nav.Link>
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/moqs" style={{ marginBottom: "8px" }}>
                      Campaigns
                    </Nav.Link>
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/orders" style={{ marginBottom: "8px" }}>
                      Orders
                    </Nav.Link>
                    { privilege === 2 && (
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/transactions" style={{ marginBottom: "8px" }}>
                      Transactions
                    </Nav.Link>
                    )}
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/recommendations" style={{ marginBottom: "8px" }}>
                      Recommendations
                    </Nav.Link>
                    { privilege === 2 && (
                    <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/promo-codes" style={{ marginBottom: "8px" }}>
                      Promos
                    </Nav.Link>
                    )}
                    {/* View More dropdown for desktop */}
                    <div className="d-none d-lg-block">
                      <Dropdown className="navbar-link text-uppercase" style={{ marginBottom: "8px" }}>
                        <Dropdown.Toggle id="view-more-dropdown">
                          View More
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          { privilege === 2 && (
                          <Dropdown.Item as={Link} to="/admin/suppliers">
                            Suppliers
                          </Dropdown.Item>
                          )}
                          <Dropdown.Item as={Link} to="/admin/colors">
                            Colors
                          </Dropdown.Item>
                          <Dropdown.Item as={Link} to="/admin/sizes">
                            Sizes
                          </Dropdown.Item>
                          <Dropdown.Item as={Link} to="/admin/send-sms">
                            Send SMS
                          </Dropdown.Item>
                          { privilege === 2 && (
                          <Dropdown.Item as={Link} to="/admin/settings">
                            Settings
                          </Dropdown.Item>
                          )}
                          <Dropdown.Item
                            onClick={() => {
                              cookies.remove("ltdn");
                              localStorage.removeItem("ltdn_exp");
                              return (window.location.href = "/signin");
                            }}
                          >
                            Log Out
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    {/* Show all links directly on mobile */}
                    <div className="d-lg-none">
                      { privilege === 2 && (
                      <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/suppliers" style={{ marginBottom: "8px" }}>
                        Suppliers
                      </Nav.Link>
                      )}
                      <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/colors" style={{ marginBottom: "8px" }}>
                        Colors
                      </Nav.Link>
                      <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/sizes" style={{ marginBottom: "8px" }}>
                        Sizes
                      </Nav.Link>
                      <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/send-sms" style={{ marginBottom: "8px" }}>
                        Send SMS
                      </Nav.Link>
                      { privilege === 2 && (
                      <Nav.Link className="navbar-link text-uppercase" as={Link} to="/admin/settings" style={{ marginBottom: "8px" }}>
                        Settings
                      </Nav.Link>
                      )}
                      <Nav.Link
                        className="navbar-link text-uppercase"
                        style={{ marginBottom: "8px" }}
                        onClick={() => {
                          cookies.remove("ltdn");
                          localStorage.removeItem("ltdn_exp");
                          return (window.location.href = "/signin");
                        }}
                      >
                        Log Out
                      </Nav.Link>
                    </div>
                  </>
                )}

                {isAuthenticated === false && (
                  <Nav.Link className="navbar-link text-uppercase" as={Link} to="/signin">
                    Sign In
                  </Nav.Link>
                )}
            </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          </Container>
        </Navbar>
        </Col>

        <Col sm="12">{this.props.children}</Col>

        <Col sm="12" className="footer">
        <Container>
          <Row>
          <Col sm="4" className="footer-item">
            <h6>Email</h6>
            <p>sales@litudian.com</p>
          </Col>
          <Col sm="4" className="footer-item">
            <h6>Address</h6>
            <p>
            Family Trade Center, 4th Floor, Tom Mboya Street, Nairobi,
            Kenya.
            </p>
          </Col>
          <Col sm="4" className="footer-item">
            <h6>Contacts</h6>
            <p>0792819290, 0780620888 </p>
          </Col>
          <Col
            sm="12"
            style={{
            marginTop: "20px",
            padding: "0 10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            }}
          >
            <p
            style={{
              color: "#fff",
              fontSize: "14px",
              fontWeight: "bold",
            }}
            >
            Litudian &copy; {new Date().getFullYear()}
            </p>
          </Col>
          </Row>
        </Container>
        </Col>

        {/* SignIn Modal */}
        <Modal show={showModal} onHide={this.toggleModal}>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={{ msisdn: "", password: "" }}
          validationSchema={signinSchema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
          const data = await this.props.signin(values);

          if (data === "") {
            return toast.warning("Incorrect Credentials !", {
            position: "bottom-center",
            });
          }

          localStorage.setItem("ltdn", data.token);

          localStorage.setItem(
            "ltdn_exp",
            Math.floor(Date.now() / 1000) + 60 * 60 * 1
          );

          toast.success("You have successfully signed in !", {
            position: "bottom-center",
          });

          return (window.location.href = "/admin");
          }}
        >
          {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          }) => (
          <div>
            <Modal.Body>
            <Form.Group as={Row} controlId="phone_number">
              <Form.Label column sm="3">
              Phone Number
              </Form.Label>

              <Col sm="9">
              <Form.Control
                type="text"
                placeholder="Phone Number"
                name="msisdn"
                isValid={touched.msisdn && !errors.msisdn}
                isInvalid={errors.msisdn && touched.msisdn}
                value={values.msisdn}
                onChange={handleChange}
              />

              {errors.msisdn && touched.msisdn && (
                <Form.Control.Feedback type="invalid">
                {errors.msisdn}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="password">
              <Form.Label column sm="3">
              Password
              </Form.Label>

              <Col sm="9">
              <Form.Control
                type="password"
                placeholder="Password"
                name="password"
                isValid={touched.password && !errors.password}
                isInvalid={errors.password && touched.password}
                value={values.password}
                onChange={handleChange}
              />

              {errors.password && touched.password && (
                <Form.Control.Feedback type="invalid">
                {errors.password}
                </Form.Control.Feedback>
              )}
              </Col>
            </Form.Group>
            </Modal.Body>

            <Modal.Footer>
            <Button variant="secondary" onClick={this.toggleModal}>
              Close
            </Button>

            <Button variant="primary" onClick={handleSubmit}>
              Sign In
            </Button>
            </Modal.Footer>
          </div>
          )}
        </Formik>
        </Modal>

        <CookieConsent
        buttonStyle={{ backgroundColor: "#FF4C00", color: "#fff" }}
        style={{
          backgroundColor: "#fff",
          color: "#000",
          boxShadow: "inset 0px 8px 19px -3px rgba(0,0,0,0.1)",
        }}
        >
        Litudian uses cookies to enhance your experience on our platform,
        analyze site usage, personalize content and assist in our marketing
        efforts. By continuing to use our website, you agree to our use of
        cookies. For more information, please review our{" "}
        <b>
          <a
          href="https://litudian.com/cookie-policy"
          target="_blank"
          rel="noreferrer"
          >
          Cookie Policy
          </a>
        </b>
        .
        </CookieConsent>
      </Row>
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth,
  };
};

export default connect(mapStateToProps, { signin })(
  withRouter(withCookies(Index))
);
